export const videos = {
    isPending: false,
    error: null,
    data: [],
};
